module.exports = __webpack_public_path__ + "static/media/Breach Time-Incident Report.4689a28f.jpg";